import { mkhctokenEventType } from "./dispatchSignInInfoEvent";
import { SignInInfo } from "./normalizeSigninResponse";
import { setSignInInfoTimeout } from "./setSignInInfoTimeout";

/**
 * @returns for unit test snapshot only
 */
export function addSignInInfoEventListener(): unknown {
  return document.addEventListener(
    mkhctokenEventType,
    (
      // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
      event
    ) => {
      return setSignInInfoTimeout((event as CustomEvent<SignInInfo>).detail);
    }
  );
}
